// extracted by mini-css-extract-plugin
export default {"textButton":"M7lahYogsLEEmn4kTR6f__textButton___"};